import ClinicianReport from './ClinicianReport';

export default ClinicianReport;
